import React from "react";

export default function ServiceProfessionals({
  title,
  description,
  cards,
  chipText,
  children,
  id,
  iconStyle,
}) {
  const defaultIconStyle = {
    filter:
      "invert(44%) sepia(8%) saturate(7470%) hue-rotate(97deg) brightness(126%) contrast(53%)",
  };

  return (
    <div id={id} className="lg:max-w-[1440px] w-full mx-auto">
      <div className=" w-full md:px-12  md:py-[64px] px-5 py-8">
        {" "}
        <div
          className={` w-full mx-auto flex flex-col gap-4 md:gap-8 lg:gap-[64px] text-white  ${
            title == "Become a Trusted Properteasy Vendor" ? "pb-0" : ""
          }`}
        >
          <div className="flex flex-col gap-3 md:gap-4  lg:gap-6  ">
            <h5 className="bg-[#3CAB5C1A] text-[#3CAB5C] px-3 py-1 rounded-full  border border-[#3CAB5C] font-medium w-fit">
              {chipText}
            </h5>
            <div className="flex gap-8 md:flex-row flex-col">
              {" "}
              <h1 className=" font-medium w-full  text-[#242424] text-[24px] md:text-[48px] leading-tight sm:leading-tight md:leading-tight lg:leading-[69px] tracking-[0]">
                {title}
              </h1>
              <h2
                style={{ letterSpacing: "0.025em" }}
                className=" text-[#242424] w-full text-[18px] md:text-[22px] mt-4"
              >
                {description}
              </h2>
            </div>
          </div>
          <div>
            {" "}
            {chipText == "Verified Vendor Onboarding" && (
              <h3 className="text-[32px] font-medium text-[#242424] mb-4">
                What we collect
              </h3>
            )}
            <div className="flex gap-[10px] flex-wrap  justify-center items-stretch w-full">
              {cards.map((card, index) => (
                <div
                  key={index}
                  className="bg-[#F6F7F9] flex-1 min-w-[260px] max-w-[350px] md:py-8 py-6 px-6 rounded-[20px]  flex flex-col justify-start"
                >
                  <img
                    style={iconStyle ?? defaultIconStyle}
                    src={card.icon}
                    alt={card.title}
                    className="mb-5 w-10 h-10"
                  />
                  <h2 className="text-[#242424] text-[18px] md:text-[22px] font-medium">
                    {card.title}
                  </h2>
                </div>
              ))}
            </div>
          </div>
          {children && (
            <div className="lg:max-w-[1440px] w-full mx-auto">{children}</div>
          )}
        </div>
      </div>
    </div>
  );
}
